import axios from "axios";
import { toastService } from "../services/toastService";
import { store } from "../redux/store";
import { clearPersistedStorage, logout } from "../redux/slices/authSlice";

// Define all possible base URLs
const BASE_URLS = {
  default: import.meta.env.VITE_API_BASE_URL, // Default from env
  contact_api: import.meta.env.VITE_API_CONTACT_URL,
  company_api: import.meta.env.VITE_API_COMPANY_URL,
};

// Axios Instance
const axiosInstance = axios.create({
  baseURL: BASE_URLS.default,
  timeout: 60000,
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const { token } = store.getState().auth;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Conditionally override base URL if meta.base is passed
    const baseKey = config.meta?.base;
    if (baseKey && BASE_URLS[baseKey]) {
      config.baseURL = BASE_URLS[baseKey];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const dispatch = store.dispatch;
    const handleLogout = () => {
      dispatch(logout());
      dispatch(clearPersistedStorage())
    };

    if (error.response) {
      if (error.response.status === 401) {
        handleLogout();
        return;
      }

      if ([409, 404, 400].includes(error.response.status)) {
        return error.response;
      }

      if (error?.response?.data?.message || error?.response?.statusText) {
        toastService.error(
          error.response.data.message || error.response.statusText
        );
      }
    } else if (error.code === "ECONNABORTED") {
      toastService.error("It's taking longer than expected. Please try again later.");
    } else {
      toastService.error(`Request failed: ${error.message}`);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
